<mat-form-field appearance="outline" [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip" matTooltipPosition="above"
  matTooltipClass="sl-tooltip">

  <mat-label>
    {{label}} <app-required *ngIf="isRequired()"></app-required>
  </mat-label>
  <span matPrefix *ngIf="isAmount">₹ &nbsp;</span>
  <input matInput *ngIf="!decimalInput && !uppercase" [type]="type && hide? type: 'text'" [formControl]="control"
    [name]="name" [placeholder]="placeholder? placeholder: ''" restrictTo [valType]="restrictedTo"
    [maxlength]="maxlength" (ngModelChange)="emitChange($event)">
  <input matInput *ngIf="!decimalInput && uppercase" [type]="type && hide? type: 'text'" [formControl]="control"
    [name]="name" [placeholder]="placeholder? placeholder: ''" restrictTo [valType]="restrictedTo"
    oninput="this.value = this.value.toUpperCase()" [maxlength]="maxlength">
  <input matInput [formControl]="control" *ngIf="decimalInput" restrictDecimal restrictTo
    [toDecimalPlaces]="decimalPlaces">
  <button mat-icon-button type="button" matSuffix (click)="hide = !hide" *ngIf="type==='password'">
    <mat-icon class="viewToggle"> {{hide?'visibility':'visibility_off'}} </mat-icon>
  </button>

  <ng-container *ngIf="control && control.invalid" ngProjectAs="mat-error">
    <mat-error *ngIf="control.hasError('required')"> {{label}} is <strong>required</strong>. </mat-error>
    <!-- <mat-error *ngIf="control.hasError('minlength')"> {{label}} must be atleast
      {{control.errors.minlength.requiredLength}}
      characters long. </mat-error> -->
    <mat-error *ngIf="control.hasError('pattern')"> {{errMsg ? errMsg : label + ' is invalid'  }} </mat-error>
    <mat-error *ngIf="control.hasError('invalid')"> {{errMsg ? errMsg : 'Invalid'}} </mat-error>
    <mat-error *ngIf="control.hasError('MatchPassword')"> Password does not match. </mat-error>
  </ng-container>
  <ng-container ngProjectAs="mat-hint">
    <mat-hint *ngIf="hint">{{hint}}</mat-hint>
  </ng-container>
</mat-form-field>
